import React from "react";
import { resolveMediaUrl, calculateMemberCount } from "./utils";

const ChatHeader = ({ currentChat, onGroupDetailsClick }) => {
  const totalMembers = calculateMemberCount(currentChat);

  return (
    <div className="d-flex justify-content-between align-items-center mb-3 border-bottom" style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 10, padding: "15px 20px", marginBottom: "10px" }}>
      <div
        className="d-flex align-items-center gap-2"
        style={{ cursor: "pointer" }}
        onClick={onGroupDetailsClick}
      >
        {currentChat.groupImage ? (
          <img
            src={resolveMediaUrl(currentChat.groupImage)}
            alt={currentChat.name || "Group"}
            className="rounded-circle"
            style={{ width: 40, height: 40, objectFit: "cover" }}
            onError={(e) => {
              e.target.style.display = "none";
              const fallback = e.target.parentElement.querySelector('.header-avatar-fallback');
              if (fallback) fallback.style.display = "flex";
            }}
          />
        ) : <div
          className="avatar-xs rounded-circle bg-primary-subtle text-primary fw-bold d-flex align-items-center justify-content-center header-avatar-fallback"
          style={{ width: 40, height: 40, display: currentChat.groupImage ? "none" : "flex" }}
        >
          {currentChat.name?.charAt(0)?.toUpperCase() || "G"}
        </div>}
        <h5 className="text-primary mb-0">{currentChat.name || "Group Chat"}</h5>
      </div>
      <div className="d-flex align-items-center" style={{ gap: 8 }}>
        <small className="text-muted">
          {currentChat.counts?.membersCount 
            ? `${currentChat.counts.membersCount} member${currentChat.counts.membersCount !== 1 ? 's' : ''}`
            : `${totalMembers} member${totalMembers !== 1 ? 's' : ''}`
          }
        </small>
      </div>
    </div>
  );
};

export default ChatHeader;

